import { IconClose16, IconWarning16 } from '@warp-ds/icons/react';
import { Button } from '@warp-ds/react';
import { useEffect, useState } from 'react';
import { dismissBroadcast, filterDismissedBroadcasts, purgeOutdatedBroadcasts } from './broadcastState';

const messagesOrEmptyArray = (messages: BroadcastMessage[] | undefined): BroadcastMessage[] => (Array.isArray(messages) ? messages : []);

export interface BroadcastMessage {
    id: number;
    message: string;
}

export interface BroadcastProps {
    url?: string;
    broadcastMessages?: BroadcastMessage[];
}

export const Broadcast = ({ url, broadcastMessages }: BroadcastProps) => {
    const [messages, setMessages] = useState(messagesOrEmptyArray(broadcastMessages));

    useEffect(() => {
        const fetchBroadcast = async (url: string) => {
            try {
                const data = await fetch(url);
                const json = await data.json();

                setMessages(messagesOrEmptyArray(json));
            } catch (_e) {
                setMessages([]);
            }
        };

        if (url) {
            fetchBroadcast(url);
        }
    }, [url]);

    purgeOutdatedBroadcasts();

    const dismissMessage = (id: number) => {
        dismissBroadcast(id);
        setMessages(messages.filter((message) => message.id !== id));
    };

    return filterDismissedBroadcasts(messages)
        .filter((entry: BroadcastMessage) => !!entry.message)
        .map((entry: BroadcastMessage) => <BroadcastMessageEntry key={entry.id} entry={entry} dismissMessage={dismissMessage} />);
};

const BroadcastMessageEntry = ({ entry, dismissMessage }: { entry: BroadcastMessage; dismissMessage: (id: number) => void }) => (
    <section className="overflow-hidden w-full px-0 sm:px-16" aria-label="Varsel" data-testid="broadcast" key={`broadcast${entry.id}`}>
        <div className="flex relative mt-16 rounded-4 border-2 border-l-4 w-full pointer-events-auto transition-all s-text-subtle s-bg-warning-subtle s-border-warning-subtle s-border-l-warning-subtle-active">
            <div className="m-16">
                <IconWarning16 className="s-icon-warning" />
            </div>
            <div role="alert" className="self-center my-8 mr-48 py-4 last-child:mb-0">
                <p id="toast-broadcast-toast-text" dangerouslySetInnerHTML={{ __html: entry.message }} />
            </div>
            <Button
                className="w-48 h-48 absolute right-0"
                utility
                quiet
                aria-label="Skjul meldingen"
                onClick={() => dismissMessage(entry.id)}>
                <IconClose16 className="s-icon-subtle" />
            </Button>
        </div>
    </section>
);
